import { useIsWeb } from '@/hooks/useIsWeb';
import { ToggleOption } from '@components/ToggleButton/types/toggleButton.types';
import { Button, Paragraph, XGroup } from 'tamagui';
import { useAppTranslation } from '@hooks/useAppTranslation';

interface ToggleButtonProps {
  value: string;
  rounded?: boolean;
  bordered?: boolean;
  options: ToggleOption[];
  onPress: (newValue: string) => void;
}

export default function ToggleButton({
  value,
  options,
  onPress,
  bordered = true,
  rounded = false,
}: ToggleButtonProps): React.ReactElement {
  const { t } = useAppTranslation();
  const isWeb = useIsWeb();
  return (
    <XGroup
      id="reports-tabs-selector"
      borderRadius={rounded ? '$4' : '$0'}
      backgroundColor="white"
      opacity={1}
      borderWidth={bordered || isWeb ? 1 : 0}
      shadowColor="$shadow"
      shadowOffset={{ width: 0, height: 1 }}
      shadowOpacity={isWeb ? 0 : 0.15}
      shadowRadius={2}
      elevation={2}
      padding={3}
      gap="$1"
    >
      {options.map((option) => {
        const isSelected = value === option.value;

        return (
          <XGroup.Item key={`toggle-item-${option.value}`}>
            <Button
              onPress={() => onPress(option.value)}
              aria-label={option.label}
              backgroundColor={isSelected ? '$color' : '$background'}
              color={isSelected ? '$color' : '$background'}
              borderWidth={0}
              borderRadius={0}
              pressStyle={{
                backgroundColor: isSelected ? '$secondary' : '$tertiary50',
              }}
              focusStyle={{
                backgroundColor: isSelected ? '$secondary' : '$tertiary50',
              }}
              size="$2"
              paddingHorizontal="$true"
            >
              <Paragraph color={isSelected ? '$background' : '$color'}>
                {t(option.label)}
              </Paragraph>
            </Button>
          </XGroup.Item>
        );
      })}
    </XGroup>
  );
}
